import { useState } from 'react';
import { trans } from '@spotahome/soyuz/client';

import { ClipboardIcon } from '@spotahome/ui-library';
import { useShare } from '@spotahome/ui-library/src/tenant/context/ShareContext';

import copyUrlToClipboard from '../utils/copyUrlToClipboard';

import RoundButtonWithIconWrapper from './RoundButtonWithIconWrapper/RoundButtonWithIconWrapper';

import './CopyToClipboardButton.scss';

const CLIPBOARD_COLOR = '#ffccef';

const CopyToClipboardButton = () => {
  const [isUrlCopied, setIsUrlCopied] = useState(false);
  const { incrementShare } = useShare();
  const setDefaultCopyState = () => {
    setIsUrlCopied(false);
  };

  const handleCopyLink = e => {
    e.stopPropagation();
    incrementShare('copy-to-clipboard');

    copyUrlToClipboard(window.location.href);
    setIsUrlCopied(true);
    setTimeout(setDefaultCopyState, 1000);
  };

  const buttonTextVariation = () =>
    isUrlCopied
      ? 'booknowcard.share.button.clipboard-link-copied'
      : 'booknowcard.share.button.clipboard-copy-link';

  return (
    <RoundButtonWithIconWrapper
      type="clipboard"
      text={trans(buttonTextVariation())}
      backgroundColor={CLIPBOARD_COLOR}
      onClick={handleCopyLink}
    >
      <ClipboardIcon theme="dark" />
    </RoundButtonWithIconWrapper>
  );
};

export default CopyToClipboardButton;
